/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/
const localStorageKey = 'ecomify_wishlist_v1'

// Add or Remove from Wishlist
window.addOrRemoveFromWishlist = async (btn) => {
    let wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || []
    const isWishlisted = wishlist.some((elem) => elem.handle === btn.dataset.productHandle)

    if (isWishlisted) {
        wishlist = wishlist.filter((elem) => elem.handle !== btn.dataset.productHandle)
    } else {
        const response = await fetch(`/products/${btn.dataset.productHandle}.js`)
        const product = await response.json()

        const variants = product.variants.map(variant =>
            ({
                id: variant.id,
                title: variant.title,
                compare_at_price: variant.compare_at_price,
                price: variant.price,
                requires_shipping: variant.requires_shipping,
                featured_image: {
                    src: variant.featured_image?.src || null
                }
            })
        )

        wishlist.push({
            id: product.id,
            handle: product.handle,
            url: product.url,
            title: product.title,
            compare_at_price: product.compare_at_price,
            price: product.price,
            price_varies: product.price_varies,
            featured_image: product.featured_image,
            vendor: product.vendor,
            time: Date.now(),
            variants
        })
    }

    localStorage.setItem(localStorageKey, JSON.stringify(wishlist))

    initWishlist()
}

// Remove from wishlist
window.onRemoveWishlistItem = (btn) => {
    let wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || []

    wishlist = wishlist.filter((elem) => elem.handle !== btn.dataset.productHandle)

    localStorage.setItem(localStorageKey, JSON.stringify(wishlist))

    initWishlist()
}

// Init Wishlist
// Note: Can be called from anywhere if an ajax change is made
const initWishlist = () => {
    const wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || []

    document.querySelectorAll('.btn-wishlist-add-remove').forEach(btn => {
        const isWishlisted = wishlist.some((elem) => elem.handle === btn.dataset.productHandle)

        if (isWishlisted) {
            btn.querySelector('svg').setAttribute('fill', 'currentColor')
            btn.setAttribute('aria-label', btn.dataset.textRemove)
            btn.classList.add('is-wishlisted')
        } else {
            btn.querySelector('svg').setAttribute('fill', 'none')
            btn.setAttribute('aria-label', btn.dataset.textAdd)
            btn.classList.remove('is-wishlisted')
        }
    })

    document.querySelectorAll('.wishlist-count-badge').forEach(badge => {
        if (wishlist.length === 0) {
            badge.setAttribute('hidden', 'hidden')
        } else {
            badge.removeAttribute('hidden')
            badge.textContent = wishlist.length
        }
    })

    if (wishlist.length) {
        const productList = document.querySelector('#offcanvas-wishlist-product-list')
        let productListItems = ''

        wishlist.forEach((product) => {
            let variantOptions = ''

            product.variants.forEach(variant => {
                variantOptions += `
                    <option 
                        value="${variant.id}"
                        data-compare-at-price="${variant.compare_at_price || ''}"
                        data-price="${variant.price}"
                        data-variant-image="${variant.featured_image.src ? Shopify.resizeImage(variant.featured_image.src, `${productList.dataset.imgWidth}x${productList.dataset.imgHeight}`, 'center') : ''}">
                        ${variant.title}
                    </option>
                `
            })

            productListItems += `
                <li class="product-item py-3">
                    <div class="row align-items-center mx-n3">
                        <div class="col-4 px-3">
                            <a class="" href="${product.url}" tabindex="-1">
                                <img 
                                    class="product-item-img img-fluid rounded ${productList.dataset.imgThumbnail}" 
                                    src="${Shopify.resizeImage(product.featured_image || 'no-image.gif', `${productList.dataset.imgWidth}x${productList.dataset.imgHeight}`, 'center')}"
                                    alt="" 
                                    width="${productList.dataset.imgWidth}"
                                    height="${productList.dataset.imgHeight}"
                                    loading="lazy">
                            </a>
                        </div>
                        <div class="col-8 px-3">
                            <h3 class="product-item-title h6 mb-0">
                                <a href="${product.url}" class="link-dark">
                                    ${product.title}
                                </a>
                            </h3>
                            <div class="shopify-product-reviews-badge" data-id="${product.id}"></div>
                            <p class="product-item-price small mb-3">
                                <span ${product.compare_at_price > product.price ? '' : 'hidden'}>
                                    <span class="product-item-price-compare text-muted me-1">
                                        <span class="visually-hidden">
                                            ${productList.dataset.textPriceRegular} &nbsp;
                                        </span>
                                        <s>
                                            ${Shopify.formatMoney(product.compare_at_price)}
                                        </s>
                                    </span>
                                    <span class="product-item-price-final">
                                        <span class="visually-hidden">
                                            ${productList.dataset.textPriceSale} &nbsp;
                                        </span>
                                        <span ${product.price_varies ? '' : 'hidden'}>
                                            ${productList.dataset.textPriceFrom}
                                        </span>
                                        ${Shopify.formatMoney(product.price)}
                                    </span>
                                </span>
                                <span class="product-item-price-final" ${product.compare_at_price > product.price ? 'hidden' : ''}>
                                    <span ${product.price_varies ? '' : 'hidden'}>
                                        ${productList.dataset.textPriceFrom}
                                    </span>
                                    ${Shopify.formatMoney(product.price)}
                                </span>
                            </p>
                            <div class="form-wrapper" ${productList.dataset.showAtcForm === 'true' ? '' : 'hidden'}>
                                <form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" onsubmit="onSubmitAtcForm(this, event)">
                                    <input type="hidden" name="form_type" value="product">
                                    <input type="hidden" name="utf8" value="✓">
                                        <div class="d-flex">
                                            <select 
                                                class="form-select form-select-sm w-100 me-3" 
                                                name="id" 
                                                aria-label="${productList.dataset.textSelectVariant}"
                                                onchange="onChangeProductItemVariant(this, event)"
                                                ${product.variants.length === 1 ? 'hidden' : ''}>
                                                ${variantOptions}
                                            </select>
                                        <button
                                            class="btn-atc btn btn-sm btn-primary px-4 flex-shrink-0"
                                            data-product-handle="${product.handle}"
                                            type="submit"
                                            name="add"
                                            data-text-add-to-cart="${productList.dataset.textAdd}">
                                            ${productList.dataset.textAdd}
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <button 
                                class="btn-remove btn btn-sm"
                                data-product-handle="${product.handle}"
                                onclick="onRemoveWishlistItem(this)"
                                aria-label="${productList.dataset.textWishlistRemove}">
                                <svg xmlns="http://www.w3.org/2000/svg" class="" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                                </svg>
                            </button>
                        </div>
                    </div>
                </li>
            `
        })
        productList.innerHTML = productListItems

        window.SPR?.initDomEls()
        window.SPR?.loadBadges()

        document.querySelectorAll('#offcanvas-wishlist .btn-atc').forEach(btn => {
            btn.addEventListener('click', () => {
                setTimeout(() => {
                    window.onRemoveWishlistItem(btn)
                    bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-wishlist').hide()
                }, 300)
            })
        })

        document.querySelector('#offcanvas-wishlist-empty').setAttribute('hidden', 'hidden')
        document.querySelector('#offcanvas-wishlist-product-list').removeAttribute('hidden')
        document.querySelector('#offcanvas-wishlist-actions')?.removeAttribute('hidden')
    } else {
        document.querySelector('#offcanvas-wishlist-empty').removeAttribute('hidden')
        document.querySelector('#offcanvas-wishlist-product-list').setAttribute('hidden', 'hidden')
        document.querySelector('#offcanvas-wishlist-product-list').innerHTML = ''
        document.querySelector('#offcanvas-wishlist-actions')?.setAttribute('hidden', 'hidden')
    }
}
initWishlist()

// Add every wishlisted item (default variant, qty 1) to the cart in one go
window.addAllWishlistToCart = async (btn) => {
    const wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || []
    if (!wishlist.length) return

    btn.disabled = true

    // Respect whichever variant the shopper has picked in each item's own dropdown
    // (only shown when wishlist_show_atc_form is on) - falls back to the first
    // variant for anything without a visible picker (single-variant products, or
    // when that setting is off).
    const listItems = document.querySelectorAll('#offcanvas-wishlist-product-list .product-item')
    const items = wishlist.map((product, index) => {
        const select = listItems[index]?.querySelector('select[name="id"]')
        const variantId = select ? Number(select.value) : product.variants[0].id
        return { id: variantId, quantity: 1 }
    })

    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
    })

    localStorage.setItem(localStorageKey, JSON.stringify([]))

    if (response.ok) {
        window.location.href = '/cart'
        return
    }

    window.refreshCartContents?.(response)
    initWishlist()
    btn.disabled = false
}

// Downloads a real PDF quote directly - one button, one job, no share-sheet detour
// (removed 7 Sep: on desktop it did nothing different from the PDF anyway, and on mobile
// it was inconsistent whether the customer got a share menu or a file).
const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)

window.downloadWishlistQuote = async (btn) => {
    const wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || []
    if (!wishlist.length) return

    const emailInput = document.getElementById('wishlist-quote-email')
    const email = (emailInput?.value || '').trim()
    const errorEl = document.querySelector('.wishlist-quote-email-error')
    if (!isValidEmail(email)) {
        if (errorEl) errorEl.hidden = false
        emailInput?.focus()
        return
    }
    if (errorEl) errorEl.hidden = true

    const items = wishlist.map(product => ({
        title: product.title,
        price: Number(product.price),
        quantity: 1,
        variantId: product.variants[0].id,
        requiresShipping: product.variants[0].requires_shipping !== false
    }))

    await window.buildAndDownloadQuote(items, btn, { email })
}

window.downloadCartQuote = async (btn) => {
    const cart = await (await fetch('/cart.js')).json()
    if (!cart.items.length) return

    const loggedInEmail = (btn.dataset.customerEmail || '').trim()
    const emailInput = document.getElementById('cart-quote-email')
    const email = loggedInEmail || (emailInput?.value || '').trim()
    const errorEl = document.querySelector('.cart-quote-email-error')
    if (!loggedInEmail && !isValidEmail(email)) {
        if (errorEl) errorEl.hidden = false
        emailInput?.focus()
        return
    }
    if (errorEl) errorEl.hidden = true

    const items = cart.items.map(item => ({
        title: item.variant_title && item.variant_title !== 'Default Title'
            ? `${item.product_title} - ${item.variant_title}`
            : item.product_title,
        price: item.price,
        quantity: item.quantity,
        variantId: item.variant_id,
        requiresShipping: item.requires_shipping !== false
    }))

    await window.buildAndDownloadQuote(items, btn, {
        role: cart.attributes?.Role || '',
        sector: cart.attributes?.Sector || '',
        email
    })
}

// Shared by the wishlist and cart "Download Quote" buttons
window.buildAndDownloadQuote = async (items, btn, meta = {}) => {
    const refNumber = 'Q-' + Date.now().toString().slice(-8)

    // Goes to /cart (not a raw Shopify cart permalink or a draft order invoice) so the shopper
    // always lands on the cart page - never skips straight to checkout - and still has to
    // answer Role/Sector, and can still change quantities before paying. bd-quote-cart-loader.liquid
    // on the cart page reads bd_add and adds these items via AJAX.
    const cartPermalink = window.location.origin + '/cart?bd_add=' +
        encodeURIComponent(items.map(item => `${item.variantId}:${item.quantity}`).join(',')) +
        '&quote_ref=' + encodeURIComponent(refNumber)

    // Quietly create a matching Shopify Draft Order too, purely as a lookup record - so a
    // customer quoting a ref number ("Q-12345678") to support can actually be found and
    // checked, tagged with that ref number. Never blocks or changes the PDF/checkout above.
    fetch('https://bd-quote-draft-order.misty-frog-2d52.workers.dev/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: items.map(item => ({ variantId: item.variantId, quantity: item.quantity, requiresShipping: item.requiresShipping })),
            refNumber,
            role: meta.role || '',
            sector: meta.sector || '',
            email: meta.email || '',
            cartLink: cartPermalink
        })
    }).catch(() => {})
    const today = new Date().toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' })
    let subtotal = 0
    items.forEach(item => { subtotal += item.price * item.quantity })
    // Flat-rate shipping only applies when at least one item in the quote actually needs
    // posting - a quote for digital-only products (ebooks, downloads) carries no shipping.
    const isDigitalOnly = items.every(item => item.requiresShipping === false)
    const shipping = isDigitalOnly ? 0 : 1499
    const total = subtotal + shipping
    const gst = total / 11

    const loadScript = (src) => new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve()
        const s = document.createElement('script')
        s.src = src
        s.onload = resolve
        s.onerror = reject
        document.head.appendChild(s)
    })

    const logoToPng = (url) => new Promise((resolve) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
            try {
                const canvas = document.createElement('canvas')
                canvas.width = img.naturalWidth
                canvas.height = img.naturalHeight
                canvas.getContext('2d').drawImage(img, 0, 0)
                resolve({ dataUrl: canvas.toDataURL('image/png'), width: img.naturalWidth, height: img.naturalHeight })
            } catch (err) {
                resolve(null)
            }
        }
        img.onerror = () => resolve(null)
        img.src = url
    })

    const plainMoney = (v) => Shopify.formatMoney(v).replace(/<[^>]*>/g, '')

    if (btn) btn.disabled = true

    const jspdfUrlsEl = document.querySelector('[data-jspdf-url]')
    await loadScript(jspdfUrlsEl.dataset.jspdfUrl)
    await loadScript(jspdfUrlsEl.dataset.jspdfAutotableUrl)

    const { jsPDF } = window.jspdf
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })
    const pageWidth = doc.internal.pageSize.getWidth()
    const marginX = 15

    const logo = await logoToPng('https://cdn.shopify.com/s/files/1/1644/3235/files/butler-diaries-logo-26-r_a10cf7bd-d998-4add-914f-465f100d2f3f.svg?v=1788674643')
    if (logo) {
        const maxW = 45, maxH = 25
        const ratio = Math.min(maxW / logo.width, maxH / logo.height)
        const w = logo.width * ratio, h = logo.height * ratio
        doc.addImage(logo.dataUrl, 'PNG', pageWidth - marginX - w, 15, w, h)
    }

    doc.setFont('helvetica', 'bold')
    doc.setFontSize(26)
    doc.text('Quote', marginX, 25)

    doc.setFontSize(10)
    doc.setFont('helvetica', 'bold')
    doc.text('Quote No.', marginX, 35)
    doc.text('Date:', marginX, 41)
    doc.setFont('helvetica', 'normal')
    doc.text(refNumber, marginX + 22, 35)
    doc.text(today, marginX + 22, 41)

    doc.autoTable({
        startY: 50,
        margin: { left: marginX, right: marginX },
        head: [['Item Description', 'Qty', 'Price', 'Item Total']],
        body: items.map(item => [
            item.title,
            String(item.quantity),
            plainMoney(item.price),
            plainMoney(item.price * item.quantity)
        ]),
        theme: 'striped',
        headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: 'bold', lineWidth: { top: 0.6, bottom: 0.4 }, lineColor: [0, 0, 0] },
        alternateRowStyles: { fillColor: [249, 249, 249] },
        columnStyles: { 1: { halign: 'center' }, 2: { halign: 'right' }, 3: { halign: 'right' } },
        styles: { font: 'helvetica', fontSize: 10, textColor: [0, 0, 0] }
    })

    const summaryRows = [['Subtotal (inc. GST)', plainMoney(subtotal)]]
    if (!isDigitalOnly) summaryRows.push(['Shipping (flat rate)', plainMoney(shipping)])
    summaryRows.push(['Includes GST', plainMoney(gst)])
    summaryRows.push(['Total', plainMoney(total)])
    const totalRowIndex = summaryRows.length - 1

    doc.autoTable({
        startY: doc.lastAutoTable.finalY + 8,
        margin: { left: pageWidth - marginX - 70, right: marginX },
        tableWidth: 70,
        body: summaryRows,
        theme: 'plain',
        columnStyles: { 0: { halign: 'left' }, 1: { halign: 'right' } },
        styles: { font: 'helvetica', fontSize: 10, textColor: [0, 0, 0], cellPadding: 1.5 },
        didParseCell: (data) => {
            if (data.row.index === totalRowIndex) {
                data.cell.styles.fontStyle = 'bold'
                data.cell.styles.lineWidth = { top: 0.6 }
                data.cell.styles.lineColor = [0, 0, 0]
            }
        }
    })

    let y = doc.lastAutoTable.finalY + 8
    const rightEdge = pageWidth - marginX

    doc.setFont('helvetica', 'italic')
    doc.setFontSize(8)
    doc.setTextColor(120, 120, 120)
    doc.text('Any active discount codes or promotions will still apply at checkout.', rightEdge, y, { align: 'right' })
    doc.setTextColor(0, 0, 0)

    y += 15

    y += 18
    doc.setFillColor(0, 0, 0)
    doc.roundedRect(pageWidth / 2 - 40, y, 80, 14, 2, 2, 'F')
    doc.setTextColor(255, 255, 255)
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(12)
    doc.text('Complete This Order', pageWidth / 2, y + 9, { align: 'center' })
    doc.link(pageWidth / 2 - 40, y, 80, 14, { url: cartPermalink })
    doc.setTextColor(0, 0, 0)

    y += 20
    doc.setFont('helvetica', 'normal')
    doc.setFontSize(8)
    doc.setTextColor(80, 80, 80)
    doc.text('Ready to order? The button above brings back exactly these items, ready to check out:', pageWidth / 2, y, { align: 'center' })
    y += 4
    doc.text(cartPermalink, pageWidth / 2, y, { align: 'center' })
    y += 6
    doc.text(
        isDigitalOnly
            ? 'Prices shown are current at time of quoting. No shipping applies to digital items.'
            : 'Prices shown are current at time of quoting and include standard flat-rate shipping.',
        pageWidth / 2, y, { align: 'center' }
    )

    y += 10
    doc.setTextColor(0, 0, 0)
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(9)
    doc.text('BUTLER DIARIES PAYMENT DETAILS', pageWidth / 2, y, { align: 'center' })
    doc.setFont('helvetica', 'normal')
    y += 4
    doc.text('Butler Diaries Pty Ltd  |  ABN: 42 680 637 754', pageWidth / 2, y, { align: 'center' })
    y += 4
    doc.text(`Bank: NAB   Name on Account: Butler Diaries   BSB: 082 356   Acc: 303506930   Ref: ${refNumber}`, pageWidth / 2, y, { align: 'center' })
    y += 4
    doc.text('Please make cheques out to Butler Diaries and post to PO Box 44, Golden Beach QLD 4551.', pageWidth / 2, y, { align: 'center' })

    y += 10
    doc.setTextColor(80, 80, 80)
    doc.text('E: info@butlerdiaries.com  /  P: 07 3608 1934  /  butlerdiaries.com', pageWidth / 2, y, { align: 'center' })

    doc.save(`Butler-Diaries-Quote-${refNumber}.pdf`)

    // Emails the customer a link to their own PDF copy, separate from the browser download above -
    // several customers have said they can't find the downloaded file again, especially on mobile.
    // Fire-and-forget, never blocks the download itself.
    if (meta.email) {
        const pdfBase64 = doc.output('datauristring').split(',')[1]
        fetch('https://bd-quote-draft-order.misty-frog-2d52.workers.dev/store-quote-pdf', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ refNumber, email: meta.email, pdfBase64 })
        }).catch(() => {})
    }

    if (btn) btn.disabled = false
}

window.addEventListener('updated.ecomify.cart', initWishlist)
window.addEventListener('updated.ecomify.collection', initWishlist)
window.addEventListener('init.ecomify.recommended_products', initWishlist)

